import * as z from 'zod';
import { testResultsEventSchema } from './test-results-event-schema.constant';
import { createEventSchema } from '../../helpers/create-event-schema.helper';
import { patientInformationEventSchema } from './patient-information-event-schema.constant';
export var baseCustomEventSchemas = {
    test_results: createEventSchema(testResultsEventSchema, 'heardigits_widget_test_results'),
    click: createEventSchema({
        value: z.string(),
    }, 'heardigits_widget_event'),
    page_view: createEventSchema({
        value: z.string(),
    }, 'heardigits_widget_event'),
    patient_information: createEventSchema(patientInformationEventSchema, 'heardigits_widget_patient_information'),
};
